<template>
  <StyledDiv
    height="100%"
    width="100%"
    justifyContent="flex-start"
    overflowX="hidden"
  >
    <StyledDiv
      minHeight="100px"
      position="fixed"
      top="0"
      left="0"
      width="100%"
      height="10%"
      alignItems="flex-start"
      justifyContent="flex-start"
    >
      <NavBar />
    </StyledDiv>
    <StyledDiv height="90%" width="100%" marginTop="100px">
      <router-view />
    </StyledDiv>
  </StyledDiv>
</template>

<script>
import { StyledDiv } from "./styled";
import NavBar from "./NavBar";

export default {
  components: {
    NavBar,
    StyledDiv
  }
};
</script>

<style>
body {
  overflow-x: hidden;
}
body,
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}
</style>
